module.exports = __webpack_public_path__ + "img/轮播6.2ce87cf3.png";